import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { supabase } from '../supabase';
import { createClient } from '@supabase/supabase-js'; // ✅ IMPORTANTE: Agregado para crear sesión secundaria
import { 
  Building2, Users, Search, 
  Zap, Plus, RefreshCcw, UserPlus, Layers,
  LayoutDashboard, Package, ShoppingCart, Landmark,
  Factory, Check, ArrowLeft, Save,
  History, Globe, Calculator, FileText, Truck,
  BarChart3, PieChart, ShoppingBag, Copy, CreditCard,
  MoreHorizontal, AlertCircle, UserX, Mail, Key, Settings, X,
  ShieldCheck, Activity, Lock, ScanLine, MapPin, Wallet, ExternalLink, Clock, CheckCircle
} from 'lucide-react';
import toast from 'react-hot-toast';
import {
  fetchSubscriptions,
  activateSubscription,
  createPaymentLink,
  fetchEffectiveMonthlyPrice,
  fetchPlans,
  fetchSubscriptionBillingConfig,
  formatPrice,
  getSubscriptionPaymentProviderMeta,
} from '../utils/astropayService';
import {
  MODULE_ONBOARDING_DEFINITIONS,
  MODULE_ONBOARDING_STATUS_COMPLETED,
  MODULE_ONBOARDING_STATUS_PENDING,
  buildStarterModuleOnboardingStatuses,
  getModuleOnboardingStatus,
  normalizeModuleOnboardingStatuses,
} from '../utils/moduleOnboarding';

// --- DEFINICIÓN DE TODOS LOS MÓDULOS DEL SISTEMA ---
const ALL_MODULES = [
    { id: 'dashboard', label: 'Dashboard', category: 'Principal' },
    
    // Ventas
    { id: 'ventas-pos', label: 'Punto de Venta', category: 'Ventas' },
    { id: 'ventas-profesional', label: 'Ventas Profesional', category: 'Ventas' },
    { id: 'ventas-historial', label: 'Historial Ventas', category: 'Ventas' },
    { id: 'caja', label: 'Caja', category: 'Ventas' },
    { id: 'clientes', label: 'Clientes', category: 'Ventas' },
    { id: 'facturacion', label: 'Facturación', category: 'Ventas' },
    { id: 'presupuestos', label: 'Presupuestos', category: 'Ventas' },
    { id: 'listas-precios', label: 'Listas de Precios', category: 'Ventas' },

    // CRM
    { id: 'crm-dashboard', label: 'CRM Mi Panel', category: 'CRM' },
    { id: 'crm-triaje', label: 'CRM Triaje', category: 'CRM' },
    { id: 'crm-proyectos', label: 'CRM Proyectos', category: 'CRM' },
    { id: 'crm-banco-horas', label: 'CRM Banco de Horas', category: 'CRM' },
    { id: 'crm-tickets', label: 'CRM Tickets', category: 'CRM' },
    { id: 'agenda', label: 'CRM Reuniones', category: 'CRM' },
    { id: 'crm-acuerdos-facturacion', label: 'CRM Acuerdos y Facturacion', category: 'CRM' },
    { id: 'crm-reportes', label: 'CRM Reportes', category: 'CRM' },
    { id: 'crm-catalogos', label: 'CRM Catalogos', category: 'CRM' },
    
    // Canal Digital
    { id: 'tienda-config', label: 'Tienda Virtual', category: 'Digital' },
    { id: 'pedidos-web', label: 'Pedidos Web', category: 'Digital' },
    { id: 'logistica', label: 'Logistica', category: 'Logistica' },

    // Compras
    { id: 'compras-ocr', label: 'Escáner IA (Nuevo)', category: 'Compras' },
    { id: 'compras-nueva', label: 'Nueva Compra', category: 'Compras' },
    { id: 'pedido-sugerido', label: 'Pedido Sugerido', category: 'Compras' },
    { id: 'compras', label: 'Historial Compras', category: 'Compras' },
    { id: 'proveedores', label: 'Proveedores', category: 'Compras' },

    // Inventario
    { id: 'inventario', label: 'Stock Actual', category: 'Inventario' },
    { id: 'productos', label: 'Productos', category: 'Inventario' },
    { id: 'inventario-transferencia', label: 'Transferencias', category: 'Inventario' },
    { id: 'inventario-ajuste', label: 'Ajustes', category: 'Inventario' },
    { id: 'inventario-etiquetas', label: 'Etiquetas', category: 'Inventario' },

    // Producción
    { id: 'produccion-registrar', label: 'Producción', category: 'Producción' },
    { id: 'pedidos-produccion', label: 'Pedidos Producción', category: 'Producción' },
    { id: 'recetas', label: 'Recetas', category: 'Producción' },
    { id: 'produccion-historial', label: 'Historial Prod.', category: 'Producción' },
    { id: 'produccion-distribucion', label: 'Distribución Costos', category: 'Producción' },

    // Finanzas
    { id: 'bancos', label: 'Bancos', category: 'Finanzas' },
    { id: 'tesoreria-cobranzas', label: 'Cobros', category: 'Finanzas' },
    { id: 'tesoreria-pagos', label: 'Pagos', category: 'Finanzas' },
    { id: 'tesoreria-transferencia', label: 'Transf. Tesorería', category: 'Finanzas' },
    { id: 'gastos', label: 'Gastos', category: 'Finanzas' },
    { id: 'gestion-costos', label: 'Gestión Costos', category: 'Finanzas' },
    { id: 'rentabilidad-ventas', label: 'Rentabilidad', category: 'Finanzas' },
    { id: 'flujo-fondos', label: 'Flujo Fondos', category: 'Finanzas' },
    { id: 'conciliacion-bancaria', label: 'Conciliacion Bancaria', category: 'Finanzas' },
    { id: 'conciliacion-ctas-ctes', label: 'Conciliacion Ctas Ctes', category: 'Finanzas' },
    { id: 'reportes-ctas-ctes', label: 'Cuentas Corrientes', category: 'Finanzas' },
    { id: 'reportes-impositivos', label: 'Reportes Impositivos', category: 'Finanzas' },

    // Sistema & IA
    { id: 'chatbot', label: 'IA Asistente', category: 'Sistema' },

    // CONFIGURACIÓN 
    { id: 'empresa-datos', label: 'Datos Empresa', category: 'Configuración' },
    { id: 'permisos', label: 'Usuarios y Roles', category: 'Configuración' },
    { id: 'sitios', label: 'Sucursales/Sitios', category: 'Configuración' },
    { id: 'categorias', label: 'Categorías', category: 'Configuración' },
    { id: 'unidades-medida', label: 'Unidades Medida', category: 'Configuración' },
    { id: 'config-sistema-datos', label: 'Config. General', category: 'Configuración' },
    { id: 'importaciones', label: 'Importaciones', category: 'Configuración' },
    { id: 'metodos-cobro', label: 'Métodos de Cobro', category: 'Configuración' },
    { id: 'condiciones-pago', label: 'Condiciones de Pago', category: 'Configuración' },
    { id: 'tipos-comprobante', label: 'Tipos Comprobante', category: 'Configuración' },
    { id: 'presupuestos-config', label: 'Config. Presupuestos', category: 'Configuración' },
    { id: 'config-facturacion', label: 'Config. Fiscal (AFIP)', category: 'Configuración' },
    { id: 'config-reportes', label: 'Reportes y Tickets', category: 'Configuración' },
    { id: 'logs', label: 'Logs de Auditoría', category: 'Configuración' },
    { id: 'config-logistica', label: 'Config. Logistica', category: 'ConfiguraciÃ³n' },
];

// --- PRESETS DE PLANES ---
const PLAN_PRESETS = {
    basic: [
        'dashboard', 'ventas-pos', 'ventas-historial', 'caja', 'clientes', 
        'productos', 'inventario', 'inventario-ajuste', 'gastos',
        'empresa-datos', 'sitios', 'categorias', 'metodos-cobro'
    ],
    premium: [
        'dashboard', 'ventas-pos', 'ventas-historial', 'caja', 'clientes', 
        'facturacion', 'presupuestos', 'productos', 'inventario', 'inventario-ajuste',
        'compras-nueva', 'pedido-sugerido', 'compras', 'proveedores', 'bancos', 'gastos', 
        'tesoreria-cobranzas', 'tesoreria-pagos', 'compras-ocr',
        'empresa-datos', 'sitios', 'categorias', 'metodos-cobro', 'condiciones-pago', 
        'config-facturacion', 'config-reportes'
    ],
    crm: ALL_MODULES.filter(m => m.category === 'CRM').map(m => m.id),
    enterprise: ALL_MODULES
      .filter(m => !['ventas-profesional', 'logs', 'logistica', 'config-logistica', 'pedidos-produccion'].includes(m.id) && m.category !== 'CRM')
      .map(m => m.id) 
};

const DEFAULT_SITE_NAME = 'Casa Central';
const DEFAULT_ROLE_NAMES = ['cajero', 'vendedor', 'operario', 'encargado', 'admin', 'administrador'];
const FULL_ACCESS_MODULE_IDS = ALL_MODULES.map(({ id }) => id);


// ── SubscriptionTab ─────────────────────────────────────────────────────
// Internal component for managing a single org's subscription.
const SubscriptionTab = ({ orgId, orgData, onRefresh }) => {
  const [subs, setSubs] = useState([]);
  const [plans, setPlans] = useState([]);
  const [effectivePricing, setEffectivePricing] = useState(null);
  const [billingProviderMeta, setBillingProviderMeta] = useState(
    getSubscriptionPaymentProviderMeta('mercadopago'),
  );
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);

  const loadData = useCallback(async () => {
    if (!orgId) return;
    setLoading(true);
    try {
      const [subsData, plansData, nextEffectivePricing, billingConfig] = await Promise.all([
        fetchSubscriptions(orgId),
        fetchPlans(),
        fetchEffectiveMonthlyPrice(orgId),
        fetchSubscriptionBillingConfig(),
      ]);
      setSubs(subsData);
      setPlans(plansData);
      setEffectivePricing(nextEffectivePricing || null);
      setBillingProviderMeta(
        billingConfig?.providerMeta || getSubscriptionPaymentProviderMeta('mercadopago'),
      );
    } catch (err) {
      console.error('[SubscriptionTab]', err);
    } finally {
      setLoading(false);
    }
  }, [orgId]);

  useEffect(() => { loadData(); }, [loadData]);

  const ss = orgData?.subscription_status || orgData?.status || 'trial';
  const planKey = orgData?.current_plan_key || orgData?.plan || 'basic';
  const planObj = plans.find(p => p.key === planKey);

  const statusColors = {
    active: 'bg-[var(--color-accent-soft)] text-[var(--color-accent-dark)] border-[color:var(--color-accent)]',
    trial: 'bg-blue-50 text-blue-600 border-blue-200',
    grace: 'bg-orange-50 text-orange-600 border-orange-200',
    expired: 'bg-red-50 text-red-600 border-red-200',
    blocked: 'bg-red-50 text-red-700 border-red-300',
  };
  const statusLabels = { active: 'Activa', trial: 'Trial', grace: 'Gracia', expired: 'Vencida', blocked: 'Bloqueada' };

  const handleManualActivate = async (sub) => {
    if (!sub || processing) return;
    setProcessing(true);
    try {
      await activateSubscription(orgId, sub.id, sub.plan_key);
      toast.success('Suscripción activada manualmente');
      await loadData();
      if (onRefresh) await onRefresh();
    } catch (err) {
      toast.error(err?.message || 'Error al activar');
    } finally {
      setProcessing(false);
    }
  };

  const handleGenerateLink = async () => {
    if (!orgId || !planObj || processing) return;
    setProcessing(true);
    try {
      const result = await createPaymentLink({
        orgId,
        planKey: planObj.key,
        planName: planObj.name,
      });
      await loadData();
      if (result.payment_url) {
        toast.success(`Link de pago generado con ${billingProviderMeta.label}`);
      } else {
        toast.success(`Suscripcion registrada con ${billingProviderMeta.label} — link pendiente`);
      }
    } catch (err) {
      const msg = err?.message || 'Error al generar link';
      if (msg.includes('credentials not configured')) {
        toast.error(billingProviderMeta.missingConfigMessage);
      } else {
        toast.error(msg);
      }
    } finally {
      setProcessing(false);
    }
  };

  const handleManualStatusChange = async (newStatus) => {
    if (processing) return;
    setProcessing(true);
    try {
      const updates = { subscription_status: newStatus, updated_at: new Date().toISOString() };
      if (newStatus === 'active') {
        updates.read_only_mode = false;
        updates.status = 'active';
      } else if (newStatus === 'expired') {
        updates.read_only_mode = true;
      } else if (newStatus === 'blocked') {
        updates.read_only_mode = true;
        updates.status = 'blocked';
      }
      const { error } = await supabase.from('organizations').update(updates).eq('id', orgId);
      if (error) throw error;
      toast.success(`Estado cambiado a "${statusLabels[newStatus] || newStatus}"`);
      if (onRefresh) await onRefresh();
    } catch (err) {
      toast.error(err?.message || 'Error al cambiar estado');
    } finally {
      setProcessing(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm p-12 flex items-center justify-center">
        <RefreshCcw size={20} className="animate-spin text-[var(--text-muted)]" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Status + Plan overview */}
      <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm overflow-hidden">
        <div className="bg-[var(--surface-2)]/50 px-6 py-4 border-b border-slate-100">
          <h3 className="text-[10px] font-black text-[var(--text-muted)] uppercase tracking-widest flex items-center gap-2">
            <Wallet size={14} /> Estado de Suscripción
          </h3>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            {/* Status */}
            <div className="text-center p-4 rounded-xl border border-slate-100 bg-[var(--surface-2)]/30">
              <p className="text-[8px] font-black uppercase tracking-widest text-[var(--text-muted)] mb-2">Estado</p>
              <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider border ${statusColors[ss] || statusColors.trial}`}>
                <span className={`w-2 h-2 rounded-full ${ss === 'active' ? 'bg-[var(--color-accent-dark)]' : ss === 'trial' ? 'bg-blue-500' : ss === 'grace' ? 'bg-orange-500' : 'bg-red-500'}`} />
                {statusLabels[ss] || ss}
              </span>
            </div>
            {/* Plan */}
            <div className="text-center p-4 rounded-xl border border-slate-100 bg-[var(--surface-2)]/30">
              <p className="text-[8px] font-black uppercase tracking-widest text-[var(--text-muted)] mb-2">Plan</p>
              <p className="text-[14px] font-black text-[var(--text-default)]">{planObj?.name || planKey}</p>
            </div>
            {/* Price */}
            <div className="text-center p-4 rounded-xl border border-slate-100 bg-[var(--surface-2)]/30">
              <p className="text-[8px] font-black uppercase tracking-widest text-[var(--text-muted)] mb-2">Precio</p>
              <p className="text-[14px] font-black text-[var(--text-default)]">
                {(planObj || effectivePricing)
                  ? formatPrice(effectivePricing?.amount_monthly ?? planObj?.price_monthly ?? 0)
                  : '—'}
                <span className="text-[9px] font-bold text-[var(--text-muted)]"> /mes</span>
              </p>
            </div>
            {/* Expires */}
            <div className="text-center p-4 rounded-xl border border-slate-100 bg-[var(--surface-2)]/30">
              <p className="text-[8px] font-black uppercase tracking-widest text-[var(--text-muted)] mb-2">Vencimiento</p>
              <p className="text-[14px] font-black text-[var(--text-default)]">
                {orgData?.subscription_expires_at
                  ? new Date(orgData.subscription_expires_at).toLocaleDateString('es-AR')
                  : orgData?.trial_ends_at
                  ? new Date(orgData.trial_ends_at).toLocaleDateString('es-AR')
                  : '—'}
              </p>
            </div>
          </div>

          {/* Manual actions */}
          <div className="flex flex-wrap gap-2 pt-4 border-t border-slate-100">
            <p className="text-[9px] font-black uppercase tracking-widest text-[var(--text-muted)] self-center mr-2">Acciones:</p>
            <button
              onClick={() => handleManualStatusChange('active')}
              disabled={processing || ss === 'active'}
              className="px-3 py-1.5 rounded-lg bg-[var(--color-accent-soft)] border border-[color:var(--color-accent)] text-[var(--color-accent-dark)] text-[9px] font-black uppercase tracking-widest hover:bg-[var(--color-accent-soft)] transition-all disabled:opacity-40"
            >
              <CheckCircle size={10} className="inline mr-1" /> Activar
            </button>
            <button
              onClick={() => handleManualStatusChange('grace')}
              disabled={processing || ss === 'grace'}
              className="px-3 py-1.5 rounded-lg bg-orange-50 border border-orange-200 text-orange-700 text-[9px] font-black uppercase tracking-widest hover:bg-orange-100 transition-all disabled:opacity-40"
            >
              <Clock size={10} className="inline mr-1" /> Gracia
            </button>
            <button
              onClick={() => handleManualStatusChange('expired')}
              disabled={processing || ss === 'expired'}
              className="px-3 py-1.5 rounded-lg bg-red-50 border border-red-200 text-red-600 text-[9px] font-black uppercase tracking-widest hover:bg-red-100 transition-all disabled:opacity-40"
            >
              <Lock size={10} className="inline mr-1" /> Vencer
            </button>
            <button
              onClick={() => handleManualStatusChange('blocked')}
              disabled={processing || ss === 'blocked'}
              className="px-3 py-1.5 rounded-lg bg-red-50 border border-red-300 text-red-700 text-[9px] font-black uppercase tracking-widest hover:bg-red-100 transition-all disabled:opacity-40"
            >
              <Lock size={10} className="inline mr-1" /> Bloquear
            </button>
            <div className="border-l border-[color:var(--border)] mx-1" />
            <button
              onClick={handleGenerateLink}
              disabled={processing}
              className="px-3 py-1.5 rounded-lg bg-[var(--color-accent-dark)] text-white text-[9px] font-black uppercase tracking-widest hover:brightness-110 transition-all disabled:opacity-40"
              title={`Genera el link usando ${billingProviderMeta.label}`}
            >
              {processing ? <RefreshCcw size={10} className="inline animate-spin mr-1" /> : <CreditCard size={10} className="inline mr-1" />}
              {`Generar link (${billingProviderMeta.label})`}
            </button>
          </div>
        </div>
      </div>

      {/* Payment history */}
      <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm overflow-hidden">
        <div className="bg-[var(--surface-2)]/50 px-6 py-4 border-b border-slate-100 flex items-center justify-between">
          <h3 className="text-[10px] font-black text-[var(--text-muted)] uppercase tracking-widest flex items-center gap-2">
            <History size={14} /> Historial de Suscripciones
          </h3>
          <span className="text-[9px] font-bold text-[var(--text-muted)]">{subs.length} registro{subs.length !== 1 ? 's' : ''}</span>
        </div>

        {subs.length === 0 ? (
          <div className="py-10 text-center text-[10px] font-bold text-[var(--text-muted)] uppercase tracking-widest">
            Sin historial de suscripciones
          </div>
        ) : (
          <table className="w-full text-left">
            <thead>
              <tr className="bg-[var(--surface-2)]/60 border-b border-slate-100 text-[9px] font-black text-[var(--text-muted)] uppercase tracking-widest">
                <th className="px-5 py-2.5">Plan</th>
                <th className="px-4 py-2.5">Período</th>
                <th className="px-4 py-2.5">Monto</th>
                <th className="px-4 py-2.5">Estado</th>
                <th className="px-4 py-2.5 text-right pr-5">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {subs.map(sub => {
                const sColors = {
                  paid: 'bg-[var(--color-accent-soft)] text-[var(--color-accent-dark)]',
                  pending: 'bg-amber-50 text-amber-700',
                  cancelled: 'bg-red-50 text-red-600',
                  expired: 'bg-[var(--surface-2)] text-[var(--text-muted)]',
                };
                const sLabels = { paid: 'Pagado', pending: 'Pendiente', cancelled: 'Cancelado', expired: 'Expirado' };
                return (
                  <tr key={sub.id} className="hover:bg-[var(--surface-2)]/60 transition-colors">
                    <td className="px-5 py-2.5 text-[10px] font-bold text-[var(--text-default)]">{sub.plan_name || sub.plan_key}</td>
                    <td className="px-4 py-2.5 text-[10px] text-[var(--text-muted)]">{sub.period_start} → {sub.period_end}</td>
                    <td className="px-4 py-2.5 text-[11px] font-black text-[var(--text-default)]">{formatPrice(sub.amount)}</td>
                    <td className="px-4 py-2.5">
                      <span className={`px-2 py-0.5 rounded text-[9px] font-black uppercase ${sColors[sub.status] || 'bg-[var(--surface-2)] text-[var(--text-muted)]'}`}>
                        {sLabels[sub.status] || sub.status}
                      </span>
                    </td>
                    <td className="px-4 py-2.5 text-right pr-5">
                      <div className="flex items-center justify-end gap-2">
                        {sub.payment_url && sub.status === 'pending' && (
                          <a href={sub.payment_url} target="_blank" rel="noopener noreferrer" className="text-[9px] font-bold text-blue-500 hover:underline flex items-center gap-1">
                            Link <ExternalLink size={10} />
                          </a>
                        )}
                        {sub.status === 'pending' && (
                          <button
                            onClick={() => handleManualActivate(sub)}
                            disabled={processing}
                            className="text-[9px] font-black text-[var(--color-accent-dark)] hover:underline disabled:opacity-50"
                          >
                            Activar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const SuperAdminEmpresas = () => {
  // --- ESTADOS ---
  const [view, setView] = useState('list'); 
  const [activeTab, setActiveTab] = useState('general'); 
  
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  
  // KPIs States
  const [stats, setStats] = useState({ orgs: 0, users: 0, inactiveUsers: 0 });

  // Form States
  const [selectedEmpresaId, setSelectedEmpresaId] = useState(null);
  const [formData, setFormData] = useState({
    name: '', plan: 'enterprise', cuit: '', status: 'active',
    full_address: '', phone: '', email: '',
    onboarding_status: 'completed',
    custom_modules: FULL_ACCESS_MODULE_IDS,
    module_onboarding_statuses: {},
  });

  const [initialSiteName, setInitialSiteName] = useState(''); // ✅ Para alta de empresa: pedir sitio inicial

  // User Management State
  const [orgUsers, setOrgUsers] = useState([]);
  const [newUserFullName, setNewUserFullName] = useState('');
  const [newUserEmail, setNewUserEmail] = useState('');
  const [newUserPass, setNewUserPass] = useState(''); 
  const [newUserRole, setNewUserRole] = useState('admin');

  const notifyOrgModulesUpdated = (organizationId) => {
    if (!organizationId || typeof window === 'undefined') return;

    const payload = {
      organizationId,
      timestamp: Date.now(),
    };

    window.dispatchEvent(new CustomEvent('impulza:org-modules-updated', { detail: payload }));
    window.localStorage.setItem('impulza:org-modules-updated', JSON.stringify(payload));
  };

  const getOrgAddress = (org) => org?.address || org?.full_address || '';

  const fetchUsersStats = async () => {
    for (const tableName of ['users', 'profiles']) {
      try {
        const [{ count: totalUsers, error: totalUsersError }, { count: totalInactiveUsers, error: totalInactiveUsersError }] =
          await Promise.all([
            supabase.from(tableName).select('id', { count: 'exact', head: true }),
            supabase.from(tableName).select('id', { count: 'exact', head: true }).eq('is_active', false),
          ]);

        if (totalUsersError) throw totalUsersError;
        if (totalInactiveUsersError) throw totalInactiveUsersError;

        return {
          users: totalUsers || 0,
          inactiveUsers: totalInactiveUsers || 0,
        };
      } catch (err) {
        console.error(`fetchUsersStats error (${tableName}):`, err);
      }
    }

    return { users: 0, inactiveUsers: 0 };
  };

  useEffect(() => {
    fetchEmpresas();
  }, []);

  const fetchEmpresas = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('organizations')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      const organizations = data || [];
      const userStats = await fetchUsersStats();

      setEmpresas(organizations);
      setStats({
        orgs: organizations.length,
        users: userStats.users,
        inactiveUsers: userStats.inactiveUsers,
      });

    } catch (error) {
      toast.error('Error al cargar empresas');
    } finally {
      setLoading(false);
    }
  };

  
  const fetchOrgUsers = async (orgId) => {
    if (!orgId) return [];
    for (const tableName of ['profiles', 'users']) {
      try {
        const { data, error } = await supabase
          .from(tableName)
          .select('*')
          .eq('organization_id', orgId)
          .order('created_at', { ascending: true });
        if (error) throw error;
        return data || [];
      } catch (err) {
        console.error(`fetchOrgUsers error (${tableName}):`, err);
      }
    }
    return [];
  };

const handleOpenForm = (org = null) => {
    if (org) {
      setSelectedEmpresaId(org.id);
      setInitialSiteName(''); // editar: no reprovisionamos sitio aquí
      setFormData({
        name: org.name,
        plan: org.plan || 'basic',
        cuit: org.cuit || '',
        status: org.status || 'active',
        full_address: getOrgAddress(org),
        phone: org.phone || '',
        email: org.email || '',
        onboarding_status: ['pending', 'configured'].includes(String(org.onboarding_status || '').toLowerCase())
          ? 'pending'
          : 'completed',
        custom_modules: Array.isArray(org.custom_modules)
          ? org.custom_modules
          : (PLAN_PRESETS[org.plan || 'basic'] || []),
        module_onboarding_statuses: normalizeModuleOnboardingStatuses(org.module_onboarding_statuses),
      });
      // ⚠️ No dependemos del join organizations -> profiles (puede estar limitado por RLS)
      fetchOrgUsers(org.id).then((u) => setOrgUsers(u));
    } else {
      setSelectedEmpresaId(null);
      setFormData({ 
          name: '', plan: 'enterprise', cuit: '', status: 'active', full_address: '', phone: '', email: '', onboarding_status: 'completed',
          custom_modules: FULL_ACCESS_MODULE_IDS,
          module_onboarding_statuses: {},
      });
      setOrgUsers([]);
      setInitialSiteName(DEFAULT_SITE_NAME);
    }
    setView('form');
    setActiveTab('general');
  };

  
  // --- HELPERS: Provisioning de tenant (sin borrar nada) ---
  const slugify = (str = '') =>
    str
      .toString()
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // remueve acentos
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)+/g, '')
      .slice(0, 50);

  const safeText = (v) => (v || '').toString().trim();

  /**
   * Provisiona configuraciones mínimas para que el tenant "arranque" sin quedar pensando.
   * Objetivo: que al crear una empresa ya existan sus datos base (sitio, centro de costo, cliente genérico, listas, etc.)
   * Nota: Esto es best-effort desde frontend (no hay transacción). A futuro ideal moverlo a RPC/Edge Function.
   */
  const provisionOrgDefaults = async ({ orgId, orgName, siteName }) => {
    const provResult = {
      cost_center_id: null,
      site_id: null,
      default_client_id: null,
      default_payment_condition_id: null,
      default_price_list_id: null,
    };

    // 1) Centro de costo
    const { data: ccData, error: ccError } = await supabase
      .from('centros_costo')
      .insert([{ organization_id: orgId, nombre: 'GENERAL' }])
      .select('id')
      .single();

    if (!ccError && ccData?.id) {
      provResult.cost_center_id = ccData.id;
    }

    // 2) Sitio inicial
    const sitioPayload = {
      organization_id: orgId,
      nombre: siteName || DEFAULT_SITE_NAME,
      direccion: safeText(formData.full_address),
      cost_center_id: provResult.cost_center_id,
      is_active: true,
      // depositos tiene default '{}', lo dejamos que lo resuelva la DB.
    };

    const { data: sitioData, error: sitioError } = await supabase
      .from('sitios')
      .insert([sitioPayload])
      .select('id')
      .single();

    if (!sitioError && sitioData?.id) {
      provResult.site_id = sitioData.id;
    }

    // 3) Cliente genérico (Consumidor Final)
    const { data: cliData, error: cliError } = await supabase
      .from('clients')
      .insert([
        {
          organization_id: orgId,
          full_name: 'CONSUMIDOR FINAL',
          doc_type: 'DNI',
          tax_condition: 'Consumidor Final',
          is_active: true,
        },
      ])
      .select('id')
      .single();

    if (!cliError && cliData?.id) {
      provResult.default_client_id = cliData.id;
    }

    // 4) Condición de pago por defecto
    const { data: pcData, error: pcError } = await supabase
      .from('payment_conditions')
      .insert([{ organization_id: orgId, name: 'Contado', days_until_due: 0, is_active: true }])
      .select('id')
      .single();

    if (!pcError && pcData?.id) {
      provResult.default_payment_condition_id = pcData.id;
    }

    // 5) Lista de precios base
    const { data: plData, error: plError } = await supabase
      .from('price_lists')
      .insert([{ organization_id: orgId, name: 'General', adjustment_percentage: 0, is_active: true }])
      .select('id')
      .single();

    if (!plError && plData?.id) {
      provResult.default_price_list_id = plData.id;
    }

    // 6) Config de impresión (best-effort)
    await supabase.from('printed_reports_config').upsert(
      [
        {
          organization_id: orgId,
          page_format: 'Hoja A4 (Estándar)',
          show_company_address: true,
          show_company_cuit: true,
          show_company_phone: true,
          show_company_email: true,
          show_client_address: true,
          show_client_cuit_dni: true,
          show_client_phone: false,
          show_client_email: false,
          footer_message: 'Gracias por su compra...',
        },
      ],
      { onConflict: 'organization_id' }
    );

    // 7) Config de tienda (slug único). A futuro: permitir múltiples tiendas.
    const baseSlug = slugify(orgName) || `org-${orgId.slice(0, 8)}`;
    const slug = `${baseSlug}-${orgId.slice(0, 4)}`;

    await supabase.from('store_config').upsert(
      [
        {
          organization_id: orgId,
          slug,
          store_title: orgName,
          always_open: true,
          show_stock: true,
          store_type: 'retail',
          default_fulfillment_site_id: provResult.site_id,
        },
      ],
      { onConflict: 'organization_id' }
    );

    // 8) Actualizar defaults en organizations
    await supabase
      .from('organizations')
      .update({
        default_site_id: provResult.site_id,
        default_client_id: provResult.default_client_id,
        default_payment_condition_id: provResult.default_payment_condition_id,
        default_price_list_id: provResult.default_price_list_id,
      })
      .eq('id', orgId);

    return provResult;
  };

  const seedOrgRoleTemplates = async ({ orgId, moduleIds }) => {
    const normalizedModules = [...new Set((moduleIds || []).filter(Boolean))];
    if (!orgId || normalizedModules.length === 0) return;

    const rows = DEFAULT_ROLE_NAMES.flatMap((roleName) =>
      normalizedModules.map((moduleId) => ({
        organization_id: orgId,
        role_name: roleName,
        module_id: moduleId,
      }))
    );

    const { error } = await supabase.from('role_templates').insert(rows);
    if (error) throw error;
  };

const handleSave = async (e) => {
    e.preventDefault();
    setProcessing(true);
    try {
      const { full_address, ...restFormData } = formData;
      const payload = {
        ...restFormData,
        address: safeText(full_address),
        onboarding_status: formData.onboarding_status === 'pending' ? 'pending' : 'completed',
        onboarding_completed_at: formData.onboarding_status === 'pending' ? null : undefined,
        onboarding_completed_by: formData.onboarding_status === 'pending' ? null : undefined,
        module_onboarding_statuses: formData.onboarding_status === 'pending'
          ? normalizeModuleOnboardingStatuses(formData.module_onboarding_statuses)
          : {},
      };

      if (payload.onboarding_completed_at === undefined) delete payload.onboarding_completed_at;
      if (payload.onboarding_completed_by === undefined) delete payload.onboarding_completed_by;

      if (selectedEmpresaId) {
        const { error } = await supabase.from('organizations').update(payload).eq('id', selectedEmpresaId);
        if (error) throw error;
        notifyOrgModulesUpdated(selectedEmpresaId);
        toast.success('Empresa actualizada');
      
      } else {
        // ✅ Alta de empresa con provisioning mínimo (sitio + defaults)
        const siteName = safeText(initialSiteName) || DEFAULT_SITE_NAME;
        const selectedModules = Array.isArray(formData.custom_modules) && formData.custom_modules.length > 0
          ? [...new Set(formData.custom_modules)]
          : FULL_ACCESS_MODULE_IDS;

        // Insert devolviendo el ID creado
        const { data: createdOrg, error: createError } = await supabase
          .from('organizations')
          .insert([{
            ...payload,
            custom_modules: selectedModules,
          }])
          .select('id, name')
          .single();

        if (createError) throw createError;

        await seedOrgRoleTemplates({
          orgId: createdOrg.id,
          moduleIds: selectedModules,
        });

        toast.success('Empresa creada. Provisionando configuración inicial...');

        // Provision best-effort para evitar "pantallas pensando" al loguear
        await provisionOrgDefaults({
          orgId: createdOrg.id,
          orgName: createdOrg.name || formData.name,
          siteName,
        });

        toast.success('Empresa provisionada (sitio + defaults).');
        notifyOrgModulesUpdated(createdOrg.id);
      }

      fetchEmpresas();
      setView('list');
    } catch (error) {
      console.error(error);
      toast.error(error?.message || 'Error al guardar');
    } finally {
      setProcessing(false);
    }
  };

  // --- LÓGICA DE CREACIÓN DE USUARIOS MEJORADA ---
  const handleAddUser = async (e) => {
    e.preventDefault();

    // Limpiamos espacios accidentales y forzamos minúsculas
    const emailToCreate = newUserEmail.toLowerCase().trim().replace(/\s/g, '');

    if (!selectedEmpresaId) return toast.error('Guarde la empresa primero');
    if (!emailToCreate || !newUserPass || !newUserFullName) return toast.error('Complete todos los campos del usuario');
    if (newUserPass.length < 6) return toast.error('La contraseña debe tener mínimo 6 caracteres');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailToCreate)) return toast.error('Formato de correo electrónico inválido');

    setProcessing(true);
    const toastId = toast.loading('Creando usuario y vinculando...');

    try {
        // ✅ 1) Cliente secundario (sin persistencia) para NO pisar sesión actual del SuperAdmin
        const tempSupabase = createClient(supabase.supabaseUrl, supabase.supabaseKey, {
            auth: { persistSession: false, autoRefreshToken: false }
        });

        // ✅ 2) Crear usuario Auth
        const { data: authData, error: authError } = await tempSupabase.auth.signUp({
            email: emailToCreate,
            password: newUserPass,
            options: {
                data: {
                    full_name: newUserFullName,
                    organization_id: selectedEmpresaId,
                    role: newUserRole
                }
            }
        });

        if (authError) {
            // 409 típicamente: "User already registered" (email duplicado)
            if (authError?.status === 409) {
                throw new Error('Ese email ya existe en Auth (conflicto 409).');
            }
            throw authError;
        }

        const userId = authData?.user?.id;
        if (!userId) throw new Error('No se pudo obtener el UID del usuario creado.');

        // ✅ 3) Garantizar perfil en public.profiles (no dependemos de RLS del cliente)
        // Recomendado: crear la RPC `admin_ensure_profile` como SECURITY DEFINER (te paso el SQL abajo).
        const { error: rpcErr } = await supabase.rpc('admin_ensure_profile', {
            p_user_id: userId,
            p_org_id: selectedEmpresaId,
            p_email: emailToCreate,
            p_full_name: newUserFullName,
            p_role: newUserRole
        });

        if (rpcErr) {
            console.error('RPC admin_ensure_profile error:', rpcErr);

            const fallbackTargets = [
                {
                    tableName: 'users',
                    payload: {
                        id: userId,
                        email: emailToCreate,
                        full_name: newUserFullName,
                        organization_id: selectedEmpresaId,
                        role: newUserRole,
                        requires_pw_update: false,
                        is_active: true
                    },
                    onConflict: 'id'
                },
                {
                    tableName: 'profiles',
                    payload: {
                        id: userId,
                        user_id: userId,
                        email: emailToCreate,
                        full_name: newUserFullName,
                        organization_id: selectedEmpresaId,
                        role: newUserRole,
                        requires_pw_update: false
                    },
                    onConflict: 'user_id'
                }
            ];

            let linked = false;
            for (const target of fallbackTargets) {
                try {
                    const { error } = await supabase.from(target.tableName).upsert(target.payload, { onConflict: target.onConflict });
                    if (!error) {
                        linked = true;
                        break;
                    }
                } catch {}
            }

            if (!linked) {
                throw new Error('Usuario creado en Auth, pero no se pudo crear el perfil (RLS). Ejecutá el SQL de la RPC/trigger.');
            }
        }

        // ✅ 4) Refrescar usuarios del tenant desde profiles (evita “aparece y desaparece” por joins/RLS)
        const updatedUsers = await fetchOrgUsers(selectedEmpresaId);
        setOrgUsers(updatedUsers);

        toast.success('Usuario creado y perfil generado.', { id: toastId });

        // Limpiar formulario de usuario
        setNewUserEmail('');
        setNewUserPass('');
        setNewUserFullName('');
        setNewUserRole('admin');

    } catch (error) {
        console.error(error);
        toast.error(error.message || 'Error al intentar crear el usuario.', { id: toastId });
    } finally {
        setProcessing(false);
    }
  };

  const handleCopyId = (e, id) => {
    e.stopPropagation();
    navigator.clipboard.writeText(id);
    toast.success("ID copiado");
  };

  const toggleModule = (modId) => {
    setFormData(prev => {
        const current = prev.custom_modules || [];
        if (current.includes(modId)) {
            return { ...prev, custom_modules: current.filter(id => id !== modId) };
        } else {
            return { ...prev, custom_modules: [...current, modId] };
        }
    });
  };

  const applyPreset = (presetKey) => {
    setFormData(prev => ({ 
        ...prev, 
        plan: presetKey, 
        custom_modules: PLAN_PRESETS[presetKey] 
    }));
    toast.success(`Aplicado perfil ${presetKey.toUpperCase()}`);
  };

  const toggleModuleOnboarding = (moduleId) => {
    setFormData((prev) => {
      const currentStatuses = normalizeModuleOnboardingStatuses(prev.module_onboarding_statuses);
      const currentStatus = getModuleOnboardingStatus(currentStatuses, moduleId);

      return {
        ...prev,
        onboarding_status: 'pending',
        module_onboarding_statuses: {
          ...currentStatuses,
          [moduleId]:
            currentStatus === MODULE_ONBOARDING_STATUS_PENDING
              ? MODULE_ONBOARDING_STATUS_COMPLETED
              : MODULE_ONBOARDING_STATUS_PENDING,
        },
      };
    });
  };

  const applyStarterOnboarding = () => {
    setFormData((prev) => ({
      ...prev,
      onboarding_status: 'pending',
      module_onboarding_statuses: {
        ...normalizeModuleOnboardingStatuses(prev.module_onboarding_statuses),
        ...buildStarterModuleOnboardingStatuses(prev.custom_modules),
      },
    }));
    toast.success('Onboarding basico activado');
  };

  const disableAllOnboarding = () => {
    setFormData((prev) => ({
      ...prev,
      onboarding_status: 'completed',
      module_onboarding_statuses: {},
    }));
    toast.success('Onboarding desactivado');
  };

  const onboardingModulesByCategory = useMemo(() => {
    return MODULE_ONBOARDING_DEFINITIONS.reduce((acc, module) => {
      if (!acc[module.category]) acc[module.category] = [];
      acc[module.category].push(module);
      return acc;
    }, {});
  }, []);

  const filteredOrgs = useMemo(() => {
    return empresas.filter(e => 
        e.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        e.cuit?.includes(searchTerm)
    );
  }, [empresas, searchTerm]);

  return (
    <div className="imp-page imp-container animate-nova-in">
      
      {/* HEADER */}
      <div className="imp-header mb-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 bg-[var(--surface)] border border-[color:var(--border)] rounded-md flex items-center justify-center shadow-sm shrink-0">
            <ShieldCheck size={18} className="text-[#10B981]" />
          </div>
          <div className="min-w-0">
            <h1 className="text-xl md:text-2xl font-black text-[var(--color-accent-dark)] tracking-tight uppercase truncate">
                {view === 'list' ? 'Super Admin' : selectedEmpresaId ? 'Editar Empresa' : 'Nueva Empresa'}
            </h1>
            <div className="flex items-center gap-2">
                <p className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-muted)]">
                    {view === 'list' ? 'Gestión central de organizaciones y licencias.' : 'Configuración de tenant y acceso.'}
                </p>
                
                {view === 'form' && selectedEmpresaId && (
                    <span className="bg-[var(--surface-2)] border border-[color:var(--border)] text-[var(--text-muted)] px-2 py-0.5 rounded text-[10px] font-mono font-bold">
                        ID: {selectedEmpresaId}
                    </span>
                )}
            </div>
          </div>
        </div>

        <div className="imp-header-actions">
            {view === 'list' ? (
                <button 
                    onClick={() => handleOpenForm()} 
                    className="px-5 py-2.5 rounded-md bg-[#10B981] text-[#18181B] shadow-lg hover:shadow-xl transition-all text-[10px] font-black uppercase tracking-widest flex items-center gap-2 border border-[#10B981]"
                >
                    <Plus size={16} strokeWidth={3} /> Nueva Empresa
                </button>
            ) : (
                <button 
                    onClick={() => setView('list')} 
                    className="px-5 py-2.5 rounded-md bg-[var(--surface)] border border-[color:var(--border)] text-[var(--text-muted)] hover:text-[#059669] shadow-sm hover:shadow-md transition-all text-[10px] font-black uppercase tracking-widest flex items-center gap-2"
                >
                    <ArrowLeft size={16} /> Volver
                </button>
            )}
        </div>
      </div>

      {view === 'list' ? (
        <>
            {/* KPI SECTION */}
            <div className="imp-kpis mb-3">
                <div className="imp-kpi">
                    <div className="flex items-center justify-between">
                        <p className="text-[9px] font-black uppercase tracking-widest text-[var(--text-muted)]">Total Empresas</p>
                        <Building2 size={16} className="text-[#059669]" />
                    </div>
                    <p className="mt-1.5 text-2xl font-black text-[var(--text-default)] tracking-tight">{stats.orgs}</p>
                    <p className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-muted)]">Tenants registrados</p>
                </div>

                <div className="imp-kpi">
                    <div className="flex items-center justify-between">
                        <p className="text-[9px] font-black uppercase tracking-widest text-[var(--text-muted)]">Usuarios Totales</p>
                        <Users size={16} className="text-[var(--color-accent-dark)]" />
                    </div>
                    <p className="mt-1.5 text-2xl font-black text-[var(--text-default)] tracking-tight">{stats.users}</p>
                    <p className="text-[10px] font-bold uppercase tracking-widest text-[var(--color-accent-dark)]">Perfiles activos</p>
                </div>

                <div className="imp-kpi">
                    <div className="flex items-center justify-between">
                        <p className="text-[9px] font-black uppercase tracking-widest text-[var(--text-muted)]">Planes Basic</p>
                        <CreditCard size={16} className="text-purple-500" />
                    </div>
                    <p className="mt-1.5 text-2xl font-black text-[var(--text-default)] tracking-tight">
                        {empresas.filter(e => e.plan === 'basic').length}
                    </p>
                    <p className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-muted)]">Nivel de suscripción</p>
                </div>
            </div>

            {/* BARRA DE FILTROS */}
            <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm p-3 mb-4">
                <div className="relative">
                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1 flex items-center gap-1 mb-1">
                        <Search size={10} /> Buscar Organización
                    </label>
                    <div className="relative">
                        <input 
                            type="text"
                            placeholder="RAZÓN SOCIAL, CUIT..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full pl-11 pr-3 py-2.5 bg-[var(--surface)] border border-slate-100 rounded-md text-[11px] font-bold outline-none focus:ring-2 focus:ring-[#059669]/10 focus:border-[#059669] shadow-sm uppercase text-[var(--text-default)]"
                        />
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-300" size={16} />
                    </div>
                </div>
            </div>

            {/* TABLA */}
            <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm overflow-hidden flex flex-col min-h-[400px]">
                <div className="overflow-x-auto imp-table-wrap">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-[var(--surface-2)]/60 border-b border-slate-100 text-[9px] font-black text-[var(--text-muted)] uppercase tracking-widest">
                                <th className="px-5 py-3 pl-5">Empresa</th>
                                <th className="px-4 py-3">CUIT</th>
                                <th className="px-4 py-3">Plan</th>
                                <th className="px-4 py-3">Suscripción</th>
                                <th className="px-4 py-3">Usuarios</th>
                                <th className="px-4 py-3">ID Sistema</th>
                                <th className="px-4 py-3 text-right pr-5">Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                            {loading ? (
                                <tr>
                                    <td colSpan="7" className="py-12 text-center text-[var(--text-muted)] text-[10px] font-bold uppercase tracking-widest">
                                        <RefreshCcw className="animate-spin mx-auto mb-2" size={20} />
                                        Cargando empresas...
                                    </td>
                                </tr>
                            ) : filteredOrgs.map(org => (
                                <tr key={org.id} onClick={() => handleOpenForm(org)} className="hover:bg-blue-50/20 transition-all cursor-pointer group">
                                    <td className="px-5 py-3 pl-5">
                                        <div className="flex items-center gap-3">
                                            <div className={`w-8 h-8 rounded-xl flex items-center justify-center border shadow-sm ${org.status === 'active' ? 'bg-[var(--surface)] border-slate-100 text-[var(--text-muted)]' : 'bg-rose-50 border-rose-100 text-rose-400'}`}>
                                                <Building2 size={14} />
                                            </div>
                                            <div>
                                                <p className="text-[11px] font-black text-[var(--color-accent-dark)] uppercase tracking-tight group-hover:text-[#059669]">{org.name}</p>
                                                <p className="text-[8px] font-bold text-[var(--text-muted)] uppercase tracking-widest">{getOrgAddress(org) || 'Sin dirección'}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-3">
                                        <span className="text-[10px] font-bold text-[var(--text-muted)] bg-[var(--surface-2)] px-2 py-0.5 rounded border border-[color:var(--border)] uppercase">
                                            {org.cuit || '—'}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3">
                                        <span className={`inline-flex items-center px-2 py-1 rounded-lg border text-[9px] font-black uppercase tracking-widest 
                                            ${org.plan === 'premium' ? 'bg-purple-50 text-purple-600 border-purple-100' : 'bg-[var(--surface-2)] text-[var(--text-muted)] border-slate-100'}`}>
                                            {org.plan}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3">
                                        {(() => {
                                            const ss = org.subscription_status || org.status || 'trial';
                                            const colors = {
                                                active: 'bg-[var(--color-accent-soft)] text-[var(--color-accent-dark)] border-emerald-100',
                                                trial: 'bg-blue-50 text-blue-600 border-blue-100',
                                                grace: 'bg-orange-50 text-orange-600 border-orange-100',
                                                expired: 'bg-red-50 text-red-600 border-red-100',
                                                blocked: 'bg-red-50 text-red-700 border-red-200',
                                                payment_pending: 'bg-amber-50 text-amber-600 border-amber-100',
                                            };
                                            const labels = { active: 'Activa', trial: 'Trial', grace: 'Gracia', expired: 'Vencida', blocked: 'Bloqueada', payment_pending: 'Pendiente' };
                                            return (
                                                <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded border text-[9px] font-black uppercase tracking-wider ${colors[ss] || colors.trial}`}>
                                                    <span className={`w-1.5 h-1.5 rounded-full ${ss === 'active' ? 'bg-[var(--color-accent-dark)]' : ss === 'trial' ? 'bg-blue-500' : ss === 'grace' ? 'bg-orange-500' : 'bg-red-500'}`} />
                                                    {labels[ss] || ss}
                                                </span>
                                            );
                                        })()}
                                    </td>
                                    <td className="px-4 py-3">
                                        <div className="flex -space-x-2 overflow-hidden items-center">
                                            {org.profiles?.slice(0, 3).map((u, i) => (
                                                <div key={i} className="inline-block h-6 w-6 rounded-full ring-2 ring-white bg-slate-200 flex items-center justify-center text-[8px] font-bold text-[var(--text-muted)] uppercase" title={u.full_name}>
                                                    {u.full_name?.charAt(0)}
                                                </div>
                                            ))}
                                            {(org.profiles?.length || 0) > 3 && (
                                                <div className="h-6 w-6 rounded-full ring-2 ring-white bg-[var(--surface-2)] flex items-center justify-center text-[8px] font-bold text-[var(--text-muted)] uppercase">
                                                    +{org.profiles.length - 3}
                                                </div>
                                            )}
                                            {(!org.profiles || org.profiles.length === 0) && (
                                                <span className="text-[9px] text-slate-300 italic pl-3">Sin usuarios</span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="px-4 py-3">
                                        <button 
                                            onClick={(e) => handleCopyId(e, org.id)} 
                                            className="flex items-center gap-1.5 text-[10px] font-mono font-bold text-[var(--text-muted)] hover:text-[#059669] bg-[var(--surface-2)] hover:bg-blue-50 px-2.5 py-1.5 rounded-lg border border-[color:var(--border)] transition-colors"
                                            title="Copiar ID completo"
                                        >
                                            {org.id.split('-')[0]}... <Copy size={12} />
                                        </button>
                                    </td>
                                    <td className="px-4 py-3 pr-5 text-right">
                                        <button className="p-1.5 text-slate-300 hover:text-[#059669] hover:bg-blue-50 rounded-lg transition-all">
                                            <MoreHorizontal size={16} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
      ) : (
        // FORM VIEW
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 animate-in fade-in slide-in-from-right-4 duration-300">
            
            {/* SIDEBAR TABS */}
            <div className="lg:col-span-1 flex lg:flex-col gap-2 overflow-x-auto no-scrollbar pb-2 lg:pb-0">
                <button 
                    onClick={() => setActiveTab('general')}
                    className={`text-left px-4 py-3 rounded-md flex items-center gap-3 text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap shrink-0 lg:w-full lg:whitespace-normal ${activeTab === 'general' ? 'bg-[#18181B] text-white shadow-lg' : 'bg-[var(--surface)] text-[var(--text-muted)] hover:bg-[var(--surface-2)]'}`}
                >
                    <Building2 size={16} /> General
                </button>
                <button 
                    onClick={() => setActiveTab('modules')}
                    className={`text-left px-4 py-3 rounded-md flex items-center gap-3 text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap shrink-0 lg:w-full lg:whitespace-normal ${activeTab === 'modules' ? 'bg-[#18181B] text-white shadow-lg' : 'bg-[var(--surface)] text-[var(--text-muted)] hover:bg-[var(--surface-2)]'}`}
                >
                    <Layers size={16} /> Planes y Módulos
                </button>
                <button 
                    onClick={() => setActiveTab('onboarding')}
                    className={`text-left px-4 py-3 rounded-md flex items-center gap-3 text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap shrink-0 lg:w-full lg:whitespace-normal ${activeTab === 'onboarding' ? 'bg-[#18181B] text-white shadow-lg' : 'bg-[var(--surface)] text-[var(--text-muted)] hover:bg-[var(--surface-2)]'}`}
                >
                    <ScanLine size={16} /> Onboarding
                </button>
                <button 
                    onClick={() => setActiveTab('users')}
                    className={`text-left px-4 py-3 rounded-md flex items-center gap-3 text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap shrink-0 lg:w-full lg:whitespace-normal ${activeTab === 'users' ? 'bg-[#18181B] text-white shadow-lg' : 'bg-[var(--surface)] text-[var(--text-muted)] hover:bg-[var(--surface-2)]'}`}
                >
                    <Users size={16} /> Usuarios
                </button>
                <button 
                    onClick={() => setActiveTab('subscription')}
                    className={`text-left px-4 py-3 rounded-md flex items-center gap-3 text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap shrink-0 lg:w-full lg:whitespace-normal ${activeTab === 'subscription' ? 'bg-[#18181B] text-white shadow-lg' : 'bg-[var(--surface)] text-[var(--text-muted)] hover:bg-[var(--surface-2)]'}`}
                >
                    <Wallet size={16} /> Suscripción
                </button>
                <button 
                    onClick={() => setActiveTab('audit')}
                    className={`text-left px-4 py-3 rounded-md flex items-center gap-3 text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap shrink-0 lg:w-full lg:whitespace-normal ${activeTab === 'audit' ? 'bg-[#18181B] text-white shadow-lg' : 'bg-[var(--surface)] text-[var(--text-muted)] hover:bg-[var(--surface-2)]'}`}
                >
                    <Activity size={16} /> Auditoría
                </button>
            </div>

            {/* CONTENT */}
            <div className="lg:col-span-3 space-y-4">
                {activeTab === 'general' && (
                    <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm overflow-hidden">
                        <div className="bg-[var(--surface-2)]/50 px-6 py-4 border-b border-slate-100">
                            <h3 className="text-[10px] font-black text-[var(--text-muted)] uppercase tracking-widest flex items-center gap-2">
                                <Settings size={14} /> Datos de la Organización
                            </h3>
                        </div>
                        <div className="p-6 space-y-4">
                            {selectedEmpresaId && (
                                <div className="p-3 bg-blue-50 border border-blue-100 rounded-xl mb-2 flex items-center justify-between">
                                    <span className="text-[10px] font-black uppercase text-blue-800">Org ID:</span>
                                    <button onClick={(e) => handleCopyId(e, selectedEmpresaId)} className="text-[11px] font-mono font-bold text-mint-600 flex items-center gap-2 hover:underline">
                                        {selectedEmpresaId} <Copy size={12} />
                                    </button>
                                </div>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="space-y-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Razón Social</label>
                                    <input 
                                        type="text" 
                                        value={formData.name}
                                        onChange={e => setFormData({...formData, name: e.target.value})}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold uppercase outline-none focus:border-[#059669] transition-all shadow-sm text-[var(--text-default)]"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">CUIT</label>
                                    <input 
                                        type="text" 
                                        value={formData.cuit}
                                        onChange={e => setFormData({...formData, cuit: e.target.value})}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold uppercase outline-none focus:border-[#059669] transition-all shadow-sm text-[var(--text-default)]"
                                    />
                                </div>
                            

                            {!selectedEmpresaId && (
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="space-y-1">
                                  <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1 flex items-center gap-1">
                                    <MapPin size={10} /> Sitio inicial (por defecto)
                                  </label>
                                  <input
                                    type="text"
                                    value={initialSiteName}
                                    onChange={(e) => setInitialSiteName(e.target.value)}
                                    className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold uppercase outline-none focus:border-[#059669] transition-all shadow-sm text-[var(--text-default)]"
                                    placeholder={DEFAULT_SITE_NAME}
                                  />
                                  <p className="text-[8px] font-bold text-[var(--text-muted)] uppercase tracking-widest ml-1 mt-1">
                                    Se crea automáticamente junto con centro de costo, cliente genérico y defaults.
                                  </p>
                                </div>
                              </div>
                            )}

</div>

                            <div className="space-y-1">
                                <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Dirección Fiscal</label>
                                <input 
                                    type="text" 
                                    value={formData.full_address}
                                    onChange={e => setFormData({...formData, full_address: e.target.value})}
                                    className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold uppercase outline-none focus:border-[#059669] transition-all shadow-sm text-[var(--text-default)]"
                                />
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                <div className="space-y-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Plan (Base)</label>
                                    <select 
                                        value={formData.plan}
                                        onChange={e => setFormData({...formData, plan: e.target.value})}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold uppercase outline-none focus:border-[#059669] cursor-pointer"
                                    >
                                        <option value="basic">Basic</option>
                                        <option value="premium">Premium</option>
                                        <option value="enterprise">Enterprise</option>
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Estado</label>
                                    <select 
                                        value={formData.status}
                                        onChange={e => setFormData({...formData, status: e.target.value})}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold uppercase outline-none focus:border-[#059669] cursor-pointer"
                                    >
                                        <option value="active">Activa</option>
                                        <option value="inactive">Suspendida</option>
                                        <option value="pending">Pendiente</option>
                                    </select>
                                </div>
                                <div className="hidden">
                                    
                                <div className="space-y-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Teléfono</label>
                                    <input 
                                        type="text" 
                                        value={formData.phone}
                                        onChange={e => setFormData({...formData, phone: e.target.value})}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold outline-none focus:border-[#059669] transition-all shadow-sm text-[var(--text-default)]"
                                        placeholder="Ej: 341..."
                                    />
                                </div>

<label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Email Contacto</label>
                                    <input 
                                        type="email" 
                                        value={formData.email}
                                        onChange={e => setFormData({...formData, email: e.target.value})}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold outline-none focus:border-[#059669] transition-all shadow-sm text-[var(--text-default)]"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Telefono</label>
                                    <input 
                                        type="text" 
                                        value={formData.phone}
                                        onChange={e => setFormData({...formData, phone: e.target.value})}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold outline-none focus:border-[#059669] transition-all shadow-sm text-[var(--text-default)]"
                                        placeholder="Ej: 341..."
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Email Contacto</label>
                                    <input 
                                        type="email" 
                                        value={formData.email}
                                        onChange={e => setFormData({...formData, email: e.target.value})}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold outline-none focus:border-[#059669] transition-all shadow-sm text-[var(--text-default)]"
                                    />
                                </div>
                            </div>

                            <div className="pt-4 flex justify-end">
                                <button 
                                    onClick={handleSave} 
                                    disabled={processing}
                                    className="px-8 py-3 rounded-md bg-[#10B981] text-[#18181B] font-black uppercase tracking-widest text-[10px] shadow-lg hover:shadow-emerald-500/20 hover:scale-[1.02] active:scale-95 transition-all flex items-center gap-2"
                                >
                                    {processing ? <RefreshCcw size={16} className="animate-spin" /> : <Save size={16} />}
                                    Guardar Cambios
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'modules' && (
                    <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm p-6 space-y-6">
                        <div className="flex items-center justify-between border-b border-slate-100 pb-4">
                            <div>
                                <h3 className="text-[10px] font-black text-[var(--text-muted)] uppercase tracking-widest">Configuración de Plan y Módulos</h3>
                                <p className="text-[9px] text-[var(--text-muted)] mt-1">Selecciona un preset o personaliza los módulos activos.</p>
                            </div>
                            <div className="flex gap-2">
                                <button onClick={() => applyPreset('basic')} className="px-3 py-1.5 bg-[var(--surface-2)] hover:bg-slate-200 rounded-lg text-[9px] font-black uppercase transition-colors border border-[color:var(--border)]">
                                    Preset Basic
                                </button>
                                <button onClick={() => applyPreset('premium')} className="px-3 py-1.5 bg-purple-50 hover:bg-purple-100 text-purple-700 rounded-lg text-[9px] font-black uppercase transition-colors border border-purple-100">
                                    Preset Premium
                                </button>
                                <button onClick={() => applyPreset('enterprise')} className="px-3 py-1.5 bg-[var(--color-accent-dark)] hover:brightness-110 text-white rounded-lg text-[9px] font-black uppercase transition-colors shadow-sm">
                                    Preset Enterprise
                                </button>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-h-[500px] overflow-y-auto pr-2 custom-scrollbar">
                            {ALL_MODULES.map(mod => {
                                const isChecked = (formData.custom_modules || []).includes(mod.id);
                                return (
                                    <div 
                                        key={mod.id} 
                                        onClick={() => toggleModule(mod.id)} 
                                        className={`cursor-pointer border rounded-xl p-3 flex items-center justify-between transition-all select-none
                                            ${isChecked 
                                                ? 'bg-[var(--color-accent-soft)] border-[color:var(--color-accent)] shadow-sm' 
                                                : 'bg-[var(--surface-2)] border-slate-100 opacity-60 hover:opacity-100 hover:bg-[var(--surface)]'
                                            }`}
                                    >
                                        <div>
                                            <p className={`text-[10px] font-black uppercase ${isChecked ? 'text-emerald-800' : 'text-[var(--text-muted)]'}`}>
                                                {mod.label}
                                            </p>
                                            <p className="text-[8px] font-bold text-[var(--text-muted)] uppercase mt-0.5">
                                                {mod.category}
                                            </p>
                                        </div>
                                        <div className={`w-5 h-5 rounded-lg border flex items-center justify-center transition-colors
                                            ${isChecked 
                                                ? 'bg-[var(--color-accent-dark)] border-[color:var(--color-accent)]' 
                                                : 'bg-[var(--surface)] border-[color:var(--border)]'
                                            }`}>
                                            {isChecked && <Check size={12} className="text-white" strokeWidth={4} />}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        
                        <div className="flex justify-end pt-4 border-t border-slate-100">
                            <button 
                                onClick={handleSave} 
                                className="px-6 py-2 bg-[#10B981] rounded-md text-[10px] font-black uppercase shadow-lg hover:shadow-emerald-500/20 hover:scale-[1.02] active:scale-95 transition-all"
                            >
                                Guardar Configuración
                            </button>
                        </div>
                    </div>
                )}

                {activeTab === 'onboarding' && (
                    <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm p-6 space-y-6">
                        <div className="flex flex-col gap-4 border-b border-slate-100 pb-4 lg:flex-row lg:items-start lg:justify-between">
                            <div>
                                <h3 className="text-[10px] font-black text-[var(--text-muted)] uppercase tracking-widest flex items-center gap-2">
                                    <ScanLine size={14} /> Onboarding General y por Modulo
                                </h3>
                                <p className="mt-1 text-[11px] text-[var(--text-muted)] max-w-3xl">
                                    Primero activamos lo basico y despues, cuando entren a cada modulo, les mostramos una guia breve. Mas adelante sobre esta base podemos sumar flechas, focos y pasos por selector sin rehacer todo.
                                </p>
                            </div>
                            <div className="flex flex-wrap gap-2">
                                <button
                                    type="button"
                                    onClick={applyStarterOnboarding}
                                    className="px-3 py-1.5 rounded-lg bg-sky-50 border border-sky-100 text-sky-700 text-[9px] font-black uppercase tracking-widest"
                                >
                                    Cargar basico
                                </button>
                                <button
                                    type="button"
                                    onClick={disableAllOnboarding}
                                    className="px-3 py-1.5 rounded-lg bg-[var(--surface-2)] border border-[color:var(--border)] text-[var(--text-muted)] text-[9px] font-black uppercase tracking-widest"
                                >
                                    Apagar todo
                                </button>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 xl:grid-cols-[320px_minmax(0,1fr)] gap-4">
                            <div className="rounded-md border border-[color:var(--border)] bg-[var(--surface-2)] p-4 space-y-3">
                                <div>
                                    <p className="text-[9px] font-black uppercase tracking-widest text-[var(--text-muted)]">Paso inicial</p>
                                    <h4 className="mt-1 text-sm font-black text-[var(--text-default)]">Onboarding base de la empresa</h4>
                                </div>
                                <select
                                    value={formData.onboarding_status}
                                    onChange={(e) => setFormData({ ...formData, onboarding_status: e.target.value })}
                                    className="w-full bg-[var(--surface)] border border-[color:var(--border)] px-3 py-2.5 rounded-md text-[10px] font-bold uppercase outline-none focus:border-[#059669] cursor-pointer"
                                >
                                    <option value="pending">Activado</option>
                                    <option value="completed">Inactivo</option>
                                </select>
                                <p className="text-[10px] leading-relaxed text-[var(--text-muted)]">
                                    Si esta activo, el cliente ve la configuracion inicial al entrar. Al terminarla, el sistema la deja como completada.
                                </p>
                            </div>

                            <div className="space-y-4">
                                {Object.entries(onboardingModulesByCategory).map(([category, modules]) => (
                                    <div key={category} className="rounded-md border border-[color:var(--border)] overflow-hidden">
                                        <div className="bg-[var(--surface-2)] px-4 py-3 border-b border-slate-100">
                                            <p className="text-[9px] font-black uppercase tracking-widest text-[var(--text-muted)]">{category}</p>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-3 p-4">
                                            {modules.map((module) => {
                                                const status = getModuleOnboardingStatus(formData.module_onboarding_statuses, module.id);
                                                const isEnabled = status === MODULE_ONBOARDING_STATUS_PENDING;
                                                const isModuleActive = (formData.custom_modules || []).includes(module.id);

                                                return (
                                                    <button
                                                        key={module.id}
                                                        type="button"
                                                        onClick={() => toggleModuleOnboarding(module.id)}
                                                        className={`text-left rounded-md border p-4 transition-all ${
                                                            isEnabled
                                                                ? 'border-sky-200 bg-sky-50 shadow-sm'
                                                                : 'border-[color:var(--border)] bg-[var(--surface)]'
                                                        } ${!isModuleActive ? 'opacity-60' : ''}`}
                                                    >
                                                        <div className="flex items-start justify-between gap-3">
                                                            <div>
                                                                <p className="text-[10px] font-black uppercase tracking-widest text-[var(--text-muted)]">
                                                                    {isModuleActive ? 'Modulo activo' : 'Modulo apagado en plan'}
                                                                </p>
                                                                <h4 className="mt-1 text-sm font-black text-[var(--text-default)]">{module.label}</h4>
                                                            </div>
                                                            <div className={`w-5 h-5 rounded-lg border flex items-center justify-center ${
                                                                isEnabled
                                                                    ? 'bg-sky-500 border-sky-500'
                                                                    : 'bg-[var(--surface)] border-[color:var(--border)]'
                                                            }`}>
                                                                {isEnabled && <Check size={12} className="text-white" strokeWidth={4} />}
                                                            </div>
                                                        </div>
                                                        <p className="mt-3 text-[11px] leading-relaxed text-[var(--text-muted)]">
                                                            {module.description}
                                                        </p>
                                                        <div className="mt-4 inline-flex items-center rounded-xl border px-2.5 py-1 text-[9px] font-black uppercase tracking-[0.18em] border-[color:var(--border)] bg-[var(--surface)] text-[var(--text-muted)]">
                                                            {isEnabled ? 'Se muestra al entrar' : 'No se muestra'}
                                                        </div>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="flex justify-end pt-4 border-t border-slate-100">
                            <button 
                                onClick={handleSave} 
                                className="px-6 py-2 bg-[#10B981] rounded-md text-[10px] font-black uppercase shadow-lg hover:shadow-emerald-500/20 hover:scale-[1.02] active:scale-95 transition-all"
                            >
                                Guardar Onboarding
                            </button>
                        </div>
                    </div>
                )}

                {activeTab === 'users' && (
                    <div className="space-y-4">
                        <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm p-6">
                            <h3 className="text-[10px] font-black text-[var(--text-muted)] uppercase tracking-widest mb-4 flex items-center gap-2">
                                <UserPlus size={14} /> Crear Nuevo Usuario y Asignar
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
                                <div className="space-y-1 md:col-span-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Nombre Completo</label>
                                    <input 
                                        type="text" 
                                        value={newUserFullName}
                                        onChange={e => setNewUserFullName(e.target.value)}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold outline-none focus:border-[#059669]"
                                        placeholder="Ej: Juan Pérez"
                                    />
                                </div>
                                <div className="space-y-1 md:col-span-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Email</label>
                                    <input 
                                        type="email" 
                                        value={newUserEmail}
                                        onChange={e => setNewUserEmail(e.target.value)}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold outline-none focus:border-[#059669]"
                                        placeholder="usuario@correo.com"
                                    />
                                </div>
                                <div className="space-y-1 md:col-span-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Contraseña</label>
                                    <input 
                                        type="password" 
                                        value={newUserPass}
                                        onChange={e => setNewUserPass(e.target.value)}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold outline-none focus:border-[#059669]"
                                        placeholder="Mínimo 6 carácteres"
                                    />
                                </div>
                                <div className="space-y-1 md:col-span-1">
                                    <label className="text-[8px] font-black text-[var(--text-muted)] uppercase tracking-widest ml-1">Rol</label>
                                    <select 
                                        value={newUserRole}
                                        onChange={e => setNewUserRole(e.target.value)}
                                        className="w-full bg-[var(--surface)] border border-slate-100 px-3 py-2.5 rounded-md text-[10px] font-bold uppercase outline-none focus:border-[#059669]"
                                    >
                                        <option value="admin">Administrador</option>
                                        <option value="cajero">Cajero</option>
                                        <option value="manager">Gerente</option>
                                    </select>
                                </div>
                                <button 
                                    onClick={handleAddUser}
                                    disabled={processing}
                                    className="px-4 py-2.5 bg-[var(--color-accent-dark)] text-white rounded-md text-[10px] font-black uppercase tracking-widest hover:brightness-110 transition-all flex items-center justify-center gap-2 h-[38px] disabled:opacity-50 md:col-span-1"
                                >
                                    {processing ? <RefreshCcw size={14} className="animate-spin" /> : <Plus size={14} />} 
                                    Agregar
                                </button>
                            </div>
                            
                            {/* Advertencia técnica */}
                            <p className="mt-3 text-[8px] font-bold text-amber-600 bg-amber-50 px-3 py-2 rounded-lg border border-amber-100 flex items-center gap-1.5">
                                <AlertCircle size={10} /> 
                                IMPORTANTE: Si la confirmación de email está deshabilitada en Supabase, crear un usuario puede cerrar tu sesión actual como administrador.
                            </p>
                        </div>

                        <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm overflow-hidden">
                            <div className="overflow-x-auto imp-table-wrap">
                                <table className="w-full text-left">
                                    <thead>
                                        <tr className="bg-[var(--surface-2)]/60 border-b border-slate-100 text-[9px] font-black text-[var(--text-muted)] uppercase tracking-widest">
                                            <th className="px-5 py-3 pl-5">Nombre</th>
                                            <th className="px-4 py-3">Email</th>
                                            <th className="px-4 py-3">Rol</th>
                                            <th className="px-4 py-3 text-right pr-5">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-50">
                                        {orgUsers.map(u => (
                                            <tr key={u.id} className="hover:bg-[var(--surface-2)] transition-colors">
                                                <td className="px-5 py-3 pl-5 text-[10px] font-bold text-[var(--color-accent-dark)] uppercase">{u.full_name}</td>
                                                <td className="px-4 py-3 text-[10px] text-[var(--text-muted)]">{u.email}</td>
                                                <td className="px-4 py-3">
                                                    <span className="bg-[var(--surface-2)] text-[var(--text-muted)] px-2 py-0.5 rounded text-[9px] font-black uppercase border border-[color:var(--border)]">{u.role}</span>
                                                </td>
                                                <td className="px-4 py-3 text-right pr-5">
                                                    <button className="text-[var(--text-muted)] hover:text-rose-500 transition-colors">
                                                        <UserX size={14} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        {orgUsers.length === 0 && (
                                            <tr><td colSpan="4" className="py-8 text-center text-[10px] font-black text-slate-300 uppercase tracking-widest">Sin usuarios registrados</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'subscription' && (
                    <SubscriptionTab orgId={selectedEmpresaId} orgData={empresas.find(e => e.id === selectedEmpresaId)} onRefresh={fetchEmpresas} />
                )}

                {activeTab === 'audit' && (
                    <div className="bg-[var(--surface)] rounded-md border border-[color:var(--border)] shadow-sm p-10 flex flex-col items-center justify-center text-center opacity-50">
                        <History size={48} className="text-slate-300 mb-4" strokeWidth={1} />
                        <h3 className="text-sm font-black text-[var(--text-muted)] uppercase tracking-widest">Registro de Cambios</h3>
                        <p className="text-[10px] text-[var(--text-muted)] mt-2 max-w-md">
                            Próximamente vas a poder ver el historial de cambios de esta organización: altas y bajas de módulos, modificaciones de plan, accesos administrativos y más.
                        </p>
                    </div>
                )}
            </div>
        </div>
      )}
    </div>
  );
};

export default SuperAdminEmpresas;
